export class ScreenshotAttachmentModel {
	public Content: string;
	public Name: string;
}